import { render, staticRenderFns } from "./highlights-card-mss.vue?vue&type=template&id=278a382f&scoped=true&"
import script from "./highlights-card-mss.vue?vue&type=script&lang=js&"
export * from "./highlights-card-mss.vue?vue&type=script&lang=js&"
import style0 from "./highlights-card-mss.vue?vue&type=style&index=0&id=278a382f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a382f",
  null
  
)

export default component.exports